module.exports = __webpack_public_path__ + "media/events/2019Show-fa0cf91f.jpg";